/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Map_Clinic_DescriptionInputs */

const en_map_clinic_description = /** @type {(inputs: Map_Clinic_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Two-level clinic with two lifts. Two fleets with distinct roles cross between floors.`)
};

const fr_map_clinic_description = /** @type {(inputs: Map_Clinic_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clinique sur deux niveaux avec deux ascenseurs. Deux flottes aux rôles distincts circulent entre les étages.`)
};

const ms_sg2_map_clinic_description = /** @type {(inputs: Map_Clinic_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klinik dua tingkat dengan dua lif. Dua armada dengan peranan berbeza bergerak antara tingkat.`)
};

/**
* | output |
* | --- |
* | "Two-level clinic with two lifts. Two fleets with distinct roles cross between floors." |
*
* @param {Map_Clinic_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const map_clinic_description = /** @type {((inputs?: Map_Clinic_DescriptionInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Map_Clinic_DescriptionInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_map_clinic_description(inputs)
	if (locale === "fr") return fr_map_clinic_description(inputs)
	return ms_sg2_map_clinic_description(inputs)
});